var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListoIconAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.29,
    height: 32.29,
    viewBox: "0 0 32.29 32.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28032",
    "data-name": "Grupo 28032",
    transform: "translate(-770.591 -216.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28028",
    "data-name": "Grupo 28028",
    transform: "translate(566.563 382.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108687",
    "data-name": "Trazado 108687",
    d: "M220.173-166.271a16.145,16.145,0,0,0-16.145,16.145,16.145,16.145,0,0,0,16.145,16.145,16.145,16.145,0,0,0,16.145-16.145A16.145,16.145,0,0,0,220.173-166.271Zm0,30.315A14.17,14.17,0,0,1,206-150.126a14.17,14.17,0,0,1,14.17-14.17,14.17,14.17,0,0,1,14.17,14.17A14.17,14.17,0,0,1,220.173-135.956Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66164",
    "data-name": "Trazado 66164",
    d: "M121.113,205.2a1.156,1.156,0,0,1-.818-.338l-3.788-3.788a1.157,1.157,0,0,1,1.635-1.636l2.969,2.969,6.757-6.758a1.157,1.157,0,0,1,1.636,1.636l-7.575,7.576A1.153,1.153,0,0,1,121.113,205.2Z",
    transform: "translate(663.722 32.145)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListoIconAlert);
export default __webpack_public_path__ + "static/media/ListoIconAlert.e8ff959cd16f1f3597908448dedcb32f.svg";
export { ForwardRef as ReactComponent };